import { useCallback, useState } from 'react';

//@ts-ignore
const useToggle: (defaultValue?: boolean) => [boolean, () => void] = (defaultValue = false) => {
    const [isOpen, setIsOpen] = useState(defaultValue);

    const toggle = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    return [isOpen, toggle];
};

export default useToggle;
